import Description from "models/Description";
import SummaryResult from "models/SummaryResult";
import Ranking from "models/Ranking";
import Distribution from "models/Distribution";
import Engagement from "models/Engagement";

export const INIT = "reportDetail/INIT";
export const SET = "reportDetail/SET";
export const SET_NEW_COMMENT = "reportDetail/SET_NEW_COMMENT";
export const UPDATE_NEW_COMMENT = "reportDetail/UPDATE_NEW_COMMENT";
export const SET_ERRORS = "reportDetail/SET_ERRORS";

export const initReportDetail = () => ({
  type: INIT
});
export const setReportDetail = res => ({
  type: SET,
  description: new Description(res.description),
  summaryResult: new SummaryResult({
    ...res.summaryResult,
    initComment: res.summaryResult.comment
  }),
  ranking: new Ranking({
    ...res.ranking,
    initComment: res.ranking.comment
  }),
  distribution: new Distribution({
    ...res.distribution,
    initComment: res.distribution.comment
  }),
  engagement: new Engagement({
    ...res.engagement,
    initComment: res.engagement.comment
  }),
  question1: res.question1,
  question2: res.question2,
  question3: res.question3,
  question4: res.question4,
  question5: res.question5,
  question6: res.question6,
  question7: res.question7,
  question8: res.question8,
  question9: res.question9,
  question10: res.question10,
  question11: res.question11,
  question12: res.question12,
  question13: res.question13,
  measureSizeEachAttr: res.measureSizeEachAttr,
  errors: []
});
export const setNewComment = (commentType, comment) => ({
  type: SET_NEW_COMMENT,
  commentType,
  comment
});
export const updateNewComment = (commentType, comment) => ({
  type: UPDATE_NEW_COMMENT,
  commentType,
  comment
});
export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

const initialState = {
  description: new Description(),
  summaryResult: new SummaryResult(),
  ranking: new Ranking(),
  distribution: new Distribution(),
  engagement: new Engagement(),
  question1: {},
  question2: {},
  question3: {},
  question4: {},
  question5: {},
  question6: {},
  question7: {},
  question8: {},
  question9: {},
  question10: {},
  question11: {},
  question12: {},
  question13: {},
  measureSizeEachAttr: [],
  errors: []
};

const reportDetail = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...initialState
      };
    }
    case SET: {
      const {
        description,
        summaryResult,
        ranking,
        distribution,
        engagement,
        question1,
        question2,
        question3,
        question4,
        question5,
        question6,
        question7,
        question8,
        question9,
        question10,
        question11,
        question12,
        question13,
        measureSizeEachAttr,
        errors
      } = action;
      return {
        ...state,
        description,
        summaryResult,
        ranking,
        distribution,
        engagement,
        question1,
        question2,
        question3,
        question4,
        question5,
        question6,
        question7,
        question8,
        question9,
        question10,
        question11,
        question12,
        question13,
        measureSizeEachAttr,
        errors
      };
    }
    case SET_NEW_COMMENT: {
      const newState = state[action.commentType].set("comment", action.comment);
      return { ...state, [action.commentType]: newState };
    }
    case UPDATE_NEW_COMMENT: {
      const newState = state[action.commentType].merge({
        comment: action.comment,
        initComment: action.comment
      });
      return { ...state, [action.commentType]: newState };
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    default:
      return state;
  }
};

export default reportDetail;



// WEBPACK FOOTER //
// ./src/redux/modules/reportDetail.js